<template>
    <div>
        <p style="display: flex;
            font-size: 30px;
            flex-direction: row;
            height: 45px;
            color: rgb(221,114,2); 
            border-bottom: solid 0.06rem rgb(193,193,193);">
            DNA methylation
        </p>
        <el-card style="width:100%;
               height:auto;
               margin-left: auto;
               margin-right: auto;
               margin-top: 15px;
               font-size: 14px;">
               <div style="width:95%;display: inline-block;vertical-align: middle;margin:auto;font-size: 18px;text-align: left;line-height: 23px;">
                In this section, we selected some representative  <strong style="font-size:22px;">DNA methylation</strong> datasets of MDD from the GEO database. 
                These datasets include samples from the brain or blood tissues. 
                <br/>We used the box scatter plot to display the methylation profile, 
                and we also used the <a href="https://www.bioconductor.org/packages/release/bioc/html/ChAMP.html">ChAMP</a> package to do the differential methylation analysis.
                We did not filter the results of differential methylation analysis and you can choose the threshold yourself.
            </div>
        </el-card>
        <el-tabs style="height:auto;margin-top: 50px;" type="border-card" v-model="activePane">
            <!-- profile -->
            <el-tab-pane label="Methylation profile" name="profile">
                <!-- map -->
                <el-card class="box-card" 
                style="height:auto;
                width:100%;
                background-color: rgba(255,208,75,0.05);
                font-size: 16px;
                margin-bottom: 5%;">
                    <p>If you don't know which probe ID the gene you want to search corresponds to in certain dataset, you can do a mapping first.</p>
                    Platform:
                    <el-select v-model="mapDataset" placeholder="Choose type" style="display: inline-block;width: 25%;">
                        <el-option
                            v-for="item in platformOption"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                Gene name:
                <input type="text" id="inputSearch" placeholder="Enter single gene name here" v-model="mapGene" style="height:35px;width:20%;">
            
                <el-button size="small" @click="map()" type="warning" style="font-size: 16px;text-align:center;margin-left:1%;width:20%;height:40px;">Map</el-button>    
                <br/><br/>Result: <input type="text" placeholder="The result will show here." v-model="mapResult" style="height:35px;width:75%;"/>
                </el-card>
                <!-- plot -->
                <div style="width:30%;height:auto;display: inline-block;vertical-align: middle;">
                        Select an expression data set: <br/>
                        <el-select v-model="activeDataset" placeholder="Choose type" style="display: inline-block;width: 80%;">
                            <el-option
                                v-for="item in methylationOption"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                        <br/><br/>
                        Enter single probe ID here: <br/>
                    <input type="text" placeholder="Enter single probe ID here" v-model="searchMethylation" style="height:35px;width:80%">
                    <br/><br/>
                    <el-button size="small" @click="getPlotData()" type="warning" style="font-size: 16px;text-align:center;margin-left:1%;width:80%;height:40px;">Submit</el-button>
                </div>

                <el-descriptions :column="3" style="width: 69%;display: inline-block;vertical-align:middle;" border>
                    <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                        <template slot="label" >GEO accession</template>
                        <template>
                            <a :href="'https://www.ncbi.nlm.nih.gov/geo/query/acc.cgi?acc='+this.activeData[this.activeDataset].accession">    {{this.activeData[this.activeDataset].accession}}   </a>
                        </template>
                    </el-descriptions-item>
                    <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                        <template slot="label" >Case and Control</template>
                        {{this.activeData[this.activeDataset].sample}} 
                    </el-descriptions-item>
                    <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                        <template slot="label" >Tissue</template>
                        {{this.activeData[this.activeDataset].tissue}} 
                    </el-descriptions-item>
                    <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                        <template slot="label" >Gender</template>
                        {{this.activeData[this.activeDataset].gender}} 
                    </el-descriptions-item>
                    <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                        <template slot="label" >Age</template>
                        {{this.activeData[this.activeDataset].age}} 
                    </el-descriptions-item>
                    <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                        <template slot="label" >PMID</template>
                        <template>
                            <a :href="'https://www.ncbi.nlm.nih.gov/pubmed/'+this.activeData.pmid">    {{this.activeData[this.activeDataset].pmid}}   </a>
                        </template>
                    </el-descriptions-item>     
                    <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                        <template slot="label" >Citation</template>
                        {{this.activeData[this.activeDataset].citation}} 
                    </el-descriptions-item>
                </el-descriptions>   
                <div id="boxplotMethylation" >
                    <BoxplotchartVue :jsonData="jsonData" 
                        :title="activeData[activeDataset].array" 
                        :value_type='activeData[activeDataset].value_type '
                        :tooltip='activeData[activeDataset].tooltip'
                        :plotTitle="title"></BoxplotchartVue>
                </div>
            </el-tab-pane>
            <!-- data-probe -->
            <el-tab-pane label="Differential methylation probe" name="probe_result">
                
                    <!-- selecter -->
                    <div style="display: flex; align-items:center;justify-content:center;"> 
                        Select domains: 
                        <span style="width: 20px;"></span>
                        <el-select @change="selectChanged" v-model="activeDataset" placeholder="Choose type" >
                            <el-option
                                v-for="item in methylationOption"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                        <span style="width: 50px;"></span>
                        <div style="margin-right: 0%;"><a href="javascript:void(0)" @click="download('dmp_filter')" style="width:200px; ">download</a></div>
                    </div>
                   
                    <br/><br/>
                    <!-- slider -->
                    <div style="display: flex; align-items：center;justify-content:center;">
                        <div class="slider-demo-block">
                            <span class="demonstration">p.value:</span>
                            <el-slider class="slider" @change="getData" v-model="p_value" show-input :max="1" :step="0.05" style="width:400px"></el-slider>
                        </div>
                        <span style="width:80px"></span>
                        <div class="slider-demo-block">
                            <span class="demonstration">p.adjust:</span>
                            <el-slider class="slider" @change="getData" v-model="p_adjust" show-input :max="1" :step="0.05" style="width:400px"></el-slider>
                        </div>
                        <br/>
                    </div>
                    <div style="display: flex; align-items：center;justify-content:center; ">
                        <div class="slider-demo-block">
                            <span class="demonstration">|logFC|:</span>
                            <el-slider class="slider" @change="getData" v-model="logfc" show-input style="width:400px" :step="0.05" :max="0.6"></el-slider>
                        </div>
                        <span style="width:80px"></span>
                        <div class="slider-demo-block">
                            <span class="demonstration">Delta beta:</span>
                            <el-slider class="slider" @change="getData" v-model="delta_beta" show-input style="width:400px" :step="0.02" :max="0.3"></el-slider>
                        </div>
                    </div>
                <el-table ref="dmpTable" id="dmp_table" :data="tableData"  style="width: 98%;margin: auto;" height=650px @sort-change='sortChange' :cell-style="{'text-align':'center'}" :header-cell-style="{'text-align':'center'}"   >
                        <el-table-column v-for='(item,key)  in DMPFields' :key='key' :formatter="item.formatter" :prop='item.key' :label='item.label' :sortable="item.sortable" :width="item.width" :min-width="item.minWidth"/>          
                    </el-table>
                    <el-pagination
                        @size-change="(val) => handleSizeChange(val)"
                        @current-change="(val) => handleCurrentChange(val)"
                        :current-page="currentPage"
                        :page-sizes="[10,20,30]"
                        :page-size="10"
                        layout="->,total, sizes, prev, pager, next, jumper"
                        :total= this.totalCount
                        style="margin-left:auto">
                    </el-pagination>

            </el-tab-pane>
            <!-- data-region -->
            <el-tab-pane label="Differential methylation region" name="region_result">
                <div style="display: flex; align-items:center;justify-content:center;"> 
                    Select domains: 
                    <span style="width: 20px;"></span>
                    <el-select @change="selectChanged" v-model="activeDataset" placeholder="Choose type" >
                        <el-option
                            v-for="item in methylationOption"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                    <span style="width: 50px;"></span>
                    <div style="margin-right: 0%;"><a href="javascript:void(0)" @click="download('dmr_filter')" style="width:200px; ">download</a></div>
                </div>
                    <br/><br/>
                    <div style="display: flex; align-items：center;justify-content:center;">
                        <div class="slider-demo-block">
                            <span class="demonstration">Area p.value:</span>
                            <el-slider class="slider" @change="getData" v-model="dmr_p_value" show-input :max="1" :step="0.05" style="width:400px"></el-slider>
                        </div>
                        <span style="width:80px"></span>
                        <div class="slider-demo-block">
                            <span class="demonstration">Area fwer:</span>
                            <el-slider class="slider" @change="getData" v-model="dmr_fwer" show-input :max="1" :step="0.05" style="width:400px"></el-slider>
                        </div>
                        <br/>
                    </div>
                <el-table ref="dmrTable" id="dmr_table" :data="tableData"  style="width: 98%;margin: auto;" height=650px @sort-change='sortChange' :cell-style="{'text-align':'center'}" :header-cell-style="{'text-align':'center'}"   >
                        <el-table-column v-for='(item,key)  in DMRFields' :key='key' :formatter="item.formatter" :prop='item.key' :label='item.label' :sortable="item.sortable" :width="item.width" :min-width="item.minWidth"/>          
                    </el-table>
                    <el-pagination
                        @size-change="(val) => handleSizeChange(val)"
                        @current-change="(val) => handleCurrentChange(val)"
                        :current-page="currentPage"
                        :page-sizes="[10,20,30]"
                        :page-size="10"
                        layout="->,total, sizes, prev, pager, next, jumper"
                        :total= this.totalCount
                        style="margin-left:auto">
                    </el-pagination>

            </el-tab-pane>
       </el-tabs>
       
        
    </div>
</template>
<script>
import{Loading}from'element-ui';
import BoxplotchartVue from '../../../chart/Boxplotchart.vue'
export default ({
    data(){
        return{       
            methylationOption:[{
                value: 'GSE201287',
                label: 'GSE201287(blood)'
            },{
                value: 'GSE88890-BA11',
                label: 'GSE88890-BA11(brain)'
            },{
                value: 'GSE88890-BA25',
                label: 'GSE88890-BA25(brain)'
            }],
            platformOption:[{
                value: 'GPL13534',
                label: 'GPL13534 Illumina HumanMethylation450 BeadChip'
            }],
            activePane:'profile',
            // plot
            title:null,
            mapDataset:'GPL13534',
            mapGene:"BDNF",
            activeDataset:'GSE201287',
            activeData:{
                // methylation
                'GSE201287':{
                    'array':['value','probe_id','sample','age','gender','type','tissue'],
                    'value_type':'Normalized Average Beta',
                    'tooltip':['sample', 'value','age','gender'],
                    'accession':'GSE201287',
                    'sample':'Case-40\nControl-40',
                    'tissue':'Blood',
                    'gender':'Female-44\nMale-36',
                    'age':'30.03±12.43',
                    'platform':'GPL13534',
                    'pmid':'35858435',
                    'citation':'Xiu J, Li J, Liu Z, Wei H et al. Elevated BICD2 DNA methylation in blood of major depressive disorder patients and reduction of depressive-like behaviors in hippocampal Bicd2-knockdown mice. Proc Natl Acad Sci U S A 2022 Jul 26;119(30):e2201967119.',
                },
                'GSE88890-BA11':{
                    'array':['value','probe_id','sample','age','gender','type','tissue'],
                    'value_type':'Normalized Average Beta',
                    'tooltip':['sample', 'value','age','gender'],
                    'accession':'GSE88890',
                    'sample':'Case-20\nControl-20',
                    'tissue':'cortex, Brodmann area 11',
                    'gender':'Female-9\nMale-31',
                    'age':'43.98±20.4',
                    'platform':'GPL13534',
                    'pmid':'28045465',
                    'citation':'Murphy TM, Crawford B, Dempster EL, Hannon E et al. Methylomic profiling of cortex samples from completed suicide cases implicates a role for PSORS1C3 in major depression and suicide. Transl Psychiatry 2017 Jan 3;7(1):e989.',
                },
                'GSE88890-BA25':{
                    'array':['value','probe_id','sample','age','gender','type','tissue'],
                    'value_type':'Normalized Average Beta',
                    'tooltip':['sample', 'value','age','gender'],
                    'accession':'GSE88890',
                    'sample':'Case-17\nControl-18',
                    'tissue':'cortex, Brodmann area 11',
                    'gender':'Female-8\nMale-27',
                    'age':'45.23±21.13',
                    'platform':'GPL13534',
                    'pmid':'28045465',
                    'citation':'Murphy TM, Crawford B, Dempster EL, Hannon E et al. Methylomic profiling of cortex samples from completed suicide cases implicates a role for PSORS1C3 in major depression and suicide. Transl Psychiatry 2017 Jan 3;7(1):e989.',
                },
            },
            searchMethylation:"cg00000029",
            jsonData:[],
            mapResult:null,
            // table
            tableData:[],
            currentPage:1,
            totalCount:1,
            pageSize:10,
            desc:null,
            sortby:null,
            p_value:0.05,
            p_adjust:1,
            logfc:0.1,
            delta_beta:0.02,
            
            dmr_p_value:0.1,
            dmr_fwer:1,
            DMPFields: [
                { key: "probe_id", label: "Probe ID", sortable: true,width:'105px'},
                { key: "logfc", label: "LogFC", sortable: true,width:'105px'},
                { key: "aveexpr", label: "AveExpr", sortable: true,width:'105px'},
                { key: "t", label: "T", sortable: true,width:'105px'},
                { key: "p_value", label: "p.value", sortable: true,width:'105px',formatter:this.rounding},
                { key: "p_adjust", label: "p.adjust", sortable: true ,width:'105px',formatter:this.rounding},
                { key: "b", label: "B",sortable: true ,width:'105px'},
                { key: "mdd_avg", label: "MDDAvg",sortable: true ,width:'105px'},
                { key: "control_avg", label: "ControlAvg",sortable: true ,width:'120px'},
                { key: "delta_beta", label: "DeltaBeta",sortable: true ,width:'120px'},
                { key: "chr", label: "Chromosome",sortable: true,width:'135px'},
                { key: "mapinfo", label: "Mapinfo",sortable: true,width:'105px'},
                { key: "strand", label: "Strand",sortable: true ,width:'105px'},
                { key: "type", label: "Probe type",sortable: true ,width:'120px'},
                { key: "gene", label: "Gene name",sortable: true ,width:'120px'},
                // { key: "feature", label: "Feature",sortable: true ,width:'120px'},
                // { key: "cgi", label: "CGI",sortable: true ,width:'105px'},
                { key: "feat_cgi", label: "Feature-CGI",sortable: true ,width:'140px'},
                { key: "ucsc_cpg_islands_name", label: "UCSC CpG islands name",sortable: true ,width:'120px'},
                { key: "dhs", label: "DHS",sortable: true,width:'90px'},
                { key: "enhancer", label: "Enhancer",sortable: true ,width:'110px'},
                { key: "phantom", label: "Phantom",sortable: true ,width:'105px'},
                { key: "probe_snps", label: "SNP",sortable: true,width:'90px'},
                { key: "probe_snps_10", label: "SNP 10bp",sortable: true ,width:'120px'},
            ],
            DMRFields: [
                { key: "chromosome", label: "Chromosome", sortable: true,width:'135px'},
                { key: "start", label: "Start", sortable: true,width:'105px'},
                { key: "end", label: "End", sortable: true,width:'105px'},
                { key: "width", label: "Width", sortable: true,width:'105px'},
                { key: "value", label: "Value", sortable: true,width:'105px'},
                { key: "area", label: "Area", sortable: true ,width:'105px'},
                { key: "cluster", label: "Cluster",sortable: true ,width:'105px'},
                { key: "indexstart", label: "Index Start",sortable: true ,width:'120px'},
                { key: "indexend", label: "Index End",sortable: true ,width:'120px'},
                { key: "l", label: "L",sortable: true ,width:'105px'},
                { key: "clusterl", label: "ClusterL",sortable: true,width:'105px'},
                { key: "p_value", label: "p.value",formatter:this.rounding,sortable: true,width:'105px'},
                { key: "fwer", label: "fwer",formatter:this.rounding,sortable: true ,width:'105px'},
                { key: "p_value_area", label: "Area p.value",formatter:this.rounding,sortable: true ,width:'130px'},
                { key: "fwer_area", label: "Area fwer",formatter:this.rounding,sortable: true ,width:'125px'},
            ],
        }
    },
    watch:{
        activePane:function(){
            this.jsonData=[]
            this.currentPage=1
            this.pageSize=10
            this.desc=null
            this.sortby=null
            this.$refs.dmrTable.clearSort()
            this.$refs.dmpTable.clearSort()
            if(this.activePane=='profile')this.getPlotData()
            else this.getData()
        }
    },
    components:{
        BoxplotchartVue
    },
    mounted(){
        this.getPlotData()
    },
    methods:{
        getPlotData(){
            var loadingInstance = Loading.service({
                    target:document.querySelector('#boxplotMethylation')
                });
                this.axios.get(this.GLOBAL.rootAddress+'visualization/expression/methylation',{
                params: { 
                    'geo':this.activeDataset,
                    'probe_id':this.searchMethylation
                }
                })
                .then(response=> {    
                    loadingInstance.close(); 
                    for(var key in response.data){
                        if(key=='gene_name')
                            this.title=this.activeDataset+":"+this.searchMethylation+" "+response.data[key]
                        else this.jsonData=response.data[key]
                    }    
                })
                .catch(error=> {
                    console.log(error);
                    loadingInstance.close();
                }); 
        },
        getData(){
            if(this.activePane=='probe_result'){
                var loadingInstance = Loading.service({
                    target:document.getElementById('dmp_table')
                });
                this.axios.get(this.GLOBAL.rootAddress+'analysis/differential/methylation/dmp',{
                params: { 
                    'pageNum': this.currentPage,
                    'pageSize': this.pageSize,
                    'sortBy':this.sortby,
                    'desc':this.desc,
                    'dataset':this.activeDataset,
                    'p_value':this.p_value,
                    'p_adjust':this.p_adjust,
                    'logfc':this.logfc,
                    'delta_beta':this.delta_beta
                    }
                })
                .then(response=> {      
                    loadingInstance.close();
                    this.totalCount=response.data.data.total;               
                    this.tableData=response.data.data.records;   
                })
                .catch(error=> {
                    loadingInstance.close();
                    console.log(error);
                });
            }else{
                var loadingInstance = Loading.service({
                    target:document.getElementById('dmr_table')
                });
                this.axios.get(this.GLOBAL.rootAddress+'analysis/differential/methylation/dmr',{
                params: { 
                    'pageNum': this.currentPage,
                    'pageSize': this.pageSize,
                    'sortBy':this.sortby,
                    'desc':this.desc,
                    'dataset':this.activeDataset,
                    'p_value':this.dmr_p_value,
                    'fwer':this.dmr_fwer,
                    }
                })
                .then(response=> {      
                    loadingInstance.close();
                    this.totalCount=response.data.data.total;               
                    this.tableData=response.data.data.records;   
                })
                .catch(error=> {
                    loadingInstance.close();
                    console.log(error);
                });
            } 
        },
        map(){
            this.axios.get(this.GLOBAL.rootAddress+'visualization/expression/methylation/map',{
            params: { 
                'geo':this.activeDataset,
                'gene_name':this.mapGene
                }
            })
            .then(response=> {      
                this.mapResult=response.data
            })
            .catch(error=> {
                console.log(error);
            });
        },
        download(file){             
            if(this.activePane=='probe_result'){
                this.axios.get(this.GLOBAL.rootAddress+'analysis/differential/methylation/dmp/download',{
                params: { 
                    'dataset':this.activeDataset,
                    'p_value':this.p_value,
                    'p_adjust':this.p_adjust,
                    'logfc':this.logfc,
                    'delta_beta':this.delta_beta
                    },
                    responseType: 'blob',
                })
                .then(response=> {      
                    let url = window.URL.createObjectURL(response.data);
                    let link = document.createElement('a');
                    link.href = url;
                    link.download = file+".xlsx";
                    document.body.appendChild(link);
                    link.click();
                    link.remove(); 
                    window.URL.revokeObjectURL(link.href);
                })
                .catch(error=> {
                    console.log(error);
                });
            }else{
                this.axios.get(this.GLOBAL.rootAddress+'analysis/differential/methylation/dmr/download',{
                params: { 
                    'dataset':this.activeDataset,
                    'p_value':this.dmr_p_value,
                    'fwer':this.dmr_fwer,
                    },
                    responseType: 'blob',
                })
                .then(response=> {      
                    let url = window.URL.createObjectURL(response.data);
                    let link = document.createElement('a');
                    link.href = url;
                    link.download = file+".xlsx";
                    document.body.appendChild(link);
                    link.click();
                    link.remove(); 
                    window.URL.revokeObjectURL(link.href);
                })
                .catch(error=> {
                    console.log(error);
                });
            }
        },
        // 改变每页显示的条数 
        handleSizeChange(val) { 
            this.pageSize=val
            this.currentPage=1
            this.getData()            
        },
        // 改变当前页数
        handleCurrentChange(val) {
            this.currentPage=val
            this.getData()
        },
        sortChange(column, prop, order){
            this.currentPage=1
            if(column.order){
                this.sortby=column.prop
                if(column.order=='ascending'){
                    this.desc=1
                }else this.desc=0
            }else{
                this.sortby=null
                this.desc=null
            }
            this.getData()
        },
        rounding(row,column) {
            return parseFloat(row[column.property]).toExponential(3)
        },
        selectChanged(){
            if (this.$refs.table){
                this.$refs.table.clearSort()
            }
            this.currentPage=1
            this.currentPageIndex=0
            this.desc=null
            this.sortby=null
            this.pageSize=10
            this.getData()
        },
    },
   
})
</script>

<style>
 .el-slider{width:100%;} 
    .el-slider__button {
        background: #FFFFFF;
        border: solid 2px  rgb(255,208,75);
    }
    .el-slider__bar{
        background: rgb(255,208,75);
    }
    .el-slider__stop {
        background-color: #DCDFE6;
    }
    .el-input-number__increase:hover {
        color:rgb(255,208,75) !important
    }
    .el-input-number__decrease:hover {
        color:rgb(255,208,75) !important
    }
    .slider-demo-block .demonstration {
        font-size: 17px;
        line-height: 44px;
        flex: 1;
        white-space: nowrap;
        margin-bottom: 0;
        align-items:center; 
        justify-content:center;
       
    }
    .slider-demo-block{
       display: flex;
    }

</style>
